(ns kyber.containers.terms-and-conditions
  (:require [kyber.components.base.text :as text]
            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.i18n.core :as i18n]))

(def classes
  (styles->classes
   {:container
    {:max-width "700px"
     :margin [(gs [:spacing :p32])
              :auto]
     :padding-bottom (gs [:spacing :p12])

     "& ol"
     {:list-style :decimal
      :padding-left (gs [:spacing :p20])

      "& li"
      {:margin-bottom (gs [:spacing :p20])}}}}))

(defn render
  [_ _]
  [:div {:class (:container classes)}
   [:img {:src "/images/logo/logo.svg"
          :alt (i18n/t* ::logo-alt)
          :style {:margin :auto
                  :margin-bottom (gs [:spacing :p40])
                  :max-width "200px"
                  :display :block}}]

   [text/display-20 :h2
    {:style {:text-align :center
             :margin-bottom (gs [:spacing :p32])}}
    (i18n/t* ::header)]

   [:div {:style {:display :flex :gap (gs [:spacing :p8])}}
    [text/body-20 :span
     {:style {:font-weight :bold}}
     (i18n/t* ::effective-date)]
    [text/body-20 :span
     (i18n/t* ::sept-2-2025)]]

   [text/body-20 :p
    (i18n/t* ::these-terms)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::scope-and-purpose-title)]

   [text/body-20 :p
    (i18n/t* ::scope-and-purpose-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::privacy-and-data-protection-title)]

   [text/body-20 :p
    (i18n/t* ::privacy-and-data-protection-content-1)]

   [text/body-20 :p
    (i18n/t* ::privacy-and-data-protection-content-2)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::account-registration-title)]

   [text/body-20 :p
    (i18n/t* ::account-registration-content)]

   [:ul {:style {:list-style :disc
                 :padding-left (gs [:spacing :p20])
                 :margin-bottom "0"}}
    [:li [text/body-20 :span (i18n/t* ::account-registration-bullet-1)]]
    [:li [text/body-20 :span (i18n/t* ::account-registration-bullet-2)]]
    [:li [text/body-20 :span (i18n/t* ::account-registration-bullet-3)]]]

   [text/body-20 :p
    (i18n/t* ::account-registration-footer)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::system-validation-title)]

   [text/body-20 :p
    (i18n/t* ::system-validation-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::license-title)]

   [text/body-20 :p
    (i18n/t* ::license-content)]

   [:ul {:style {:list-style :disc
                 :padding-left (gs [:spacing :p20])
                 :margin-bottom "0"}}
    [:li [text/body-20 :span (i18n/t* ::license-bullet-1)]]
    [:li [text/body-20 :span (i18n/t* ::license-bullet-2)]]
    [:li [text/body-20 :span (i18n/t* ::license-bullet-3)]]]

   [text/body-20 :p
    (i18n/t* ::license-footer)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::medical-disclaimer-title)]

   [text/body-20 :p
    (i18n/t* ::medical-disclaimer-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::third-party-title)]

   [text/body-20 :p
    (i18n/t* ::third-party-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::platform-availability-title)]

   [text/body-20 :p
    (i18n/t* ::platform-availability-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::limitation-liability-title)]

   [text/body-20 :p
    (i18n/t* ::limitation-liability-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::indemnification-title)]

   [text/body-20 :p
    (i18n/t* ::indemnification-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::termination-title)]

   [text/body-20 :p
    (i18n/t* ::termination-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::governing-law-title)]

   [text/body-20 :p
    (i18n/t* ::governing-law-content)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::notices-title)]

   [text/body-20 :p
    (i18n/t* ::notices-content)]

   [text/body-20 :p
    {:style {:font-weight :bold
             :margin-bottom "0"}}
    (i18n/t* ::notices-company)]

   [text/body-20 :p
    {:style {:white-space :pre-line
             :margin-top "0"}}
    (i18n/t* ::notices-address)]

   [text/body-20 :p
    {:style {:font-weight :bold}}
    (i18n/t* ::entire-agreement-title)]

   [text/body-20 :p
    {:style {:margin-bottom (gs [:spacing :p40])}}
    (i18n/t* ::entire-agreement-content)]])
